<template>
  <div :class="{'document-wrapper':isDocumentlisting}">
    <div class="status-msg my-md" v-if="isLoadingData">Loading...</div>
    <div class="status-msg my-md" v-else-if="!documentsConfig || !documentsConfig.length">
      <span>
        <svgicon name="empty-materials" width="250" height="120" :original="true" />
        <p>{{$t('INDENT_NO_DOCUMENT_GENERATED')}}</p>
      </span>
    </div>
    <div v-else-if="!isLoadingData">
      <!-- start of shipment and delivery details -->
      <div v-if="!isSubDocView">
        <h5 class="drawer-sub-title mb-15 mt-0">
          {{$t('INDENT_SHIPMENT_DOCUMENTS')}}
          <div class="f-right">
            <Button type="text" size="mini" @click="downloadDocumentation()">Download</Button>
            <!-- <Button type="text" size="mini" @click="reTriggerDocuments()">Re-Trigger</Button> -->
            <Button type="text" size="mini" @click="getShipmentDocuments()">Refresh</Button>
            <Button :loading="retryAllLoading" v-if="$hasPermission('retry_all_documents')" type="text" size="mini" @click="regenerateAllDocuments()">Retry All</Button>
            <Button type="text" :loading="reTriggerLoading" size="mini" @click="reTriggerDocuments()">Re-Trigger</Button>
            <Button v-if="!isReadOnlyUser" type="text" size="mini" @click="printDocumentation()">Print Selected</Button>
          </div>
        </h5>
        <div class="content-scroll-inner space-top mx-pd-15" style="width:800px">
          <!-- start of shipment level docs -->
          <TagwithAttachment
            :indentDocuments="shipmentDocuments"
            :documentConfig="documentsConfig"
            :failedDocuments="failedDocuments"
            :selectedDocuments="selectedDocuments"
            @selectDocument="selectSingleDocument"
            @changeCopiesNumber="changeCopiesNumber"
            printLevel="shipment"
          ></TagwithAttachment>
          <!-- end of shipment level docs -->
          <Collapse
            v-model="activeDeliveryId"
            accordion
            class="collapse-slider mx-15"
            @tab-click="changeDeliveryTab"
          >
            <CollapseItem v-for="(deliveryId,index) in deliveryIdList" :key="index" :name="deliveryId.id">
              <!-- start of delivery level docs -->
              <template slot="title">{{ `${deliveryId && deliveryId.id}` }} {{ `${deliveryId && deliveryId.parent ? '*' : ''}` }}</template>
              <TagwithAttachment
                :indentDocuments="currentDeliveryDocuments"
                :documentConfig="documentsConfig"
                :levelId="deliveryId.id"
                :selectedDocuments="selectedDocuments"
                @selectDocument="selectSingleDocument"
                @changeCopiesNumber="changeCopiesNumber"
                printLevel="delivery"
              ></TagwithAttachment>
              <!-- end of delivery level docs -->
        <!-- start of carton docs config-->
        <h5 class="drawer-sub-title mt-0">
          {{$t('INDENT_CARTON_DOCUMENTS')}}
        </h5>
        <div class="list-multi">
          <div class="list-view"
            v-for="(cartonConfig,index) in getAllCartonDocKeyName"
            :key="index"
          >
            <span>
              <label>{{cartonConfig.name}}</label>
              <!-- <span class="badge-small badge-yellow">
                5 / 6
              </span> -->
            </span>
            <!-- <span>
              <label>Copies</label>
              <div>2</div>
            </span> -->
            <span class="action-btn text-right">
              <a href="javascript:void(0)" class="link-action d-inline" @click="viewCartonDocuments(cartonConfig)">
                <svgicon name="icon-view" width="10" height="8" />View
              </a>
            </span>
          </div>
        </div>
         <!-- end of carton docs config-->
        <!-- start of item docs config-->
        <div v-if="getAllItemDocKeyName && getAllItemDocKeyName.length">
          <h5 class="drawer-sub-title mt-0">
            {{$t('INDENT_ITEM_DOCUMENTS')}}
          </h5>
          <div class="list-multi">
            <div class="list-view"
              v-for="(itemConfig,index) in getAllItemDocKeyName"
              :key="index"
            >
              <span>
                <label>{{itemConfig.name}}</label>
              </span>
              <span class="action-btn text-right">
                <a href="javascript:void(0)" class="link-action d-inline" @click="viewItemDocuments(itemConfig)">
                  <svgicon name="icon-view" width="10" height="8" />View
                </a>
              </span>
            </div>
          </div>
        </div>
         <!-- end of item docs config-->
            </CollapseItem>
          </Collapse>
        </div>
      </div>
      <!-- end of shipment and delivery details -->
     <!-- start of carton details -->
    <CartonDocuments v-else-if="currentSubDoc === 'carton'"
      :config="selectedConfig"
      :deliveryId="activeDeliveryId"
      :currentDepotId="currentDepotId"
      :orderNumber="order.order_number"
      @closeCartonView="closeCartonView"
      :isReadOnlyUser="isReadOnlyUser"
    >
    </CartonDocuments>
    <!-- end of carton details -->
    <!-- start of item details -->
    <ItemDocuments v-else-if="currentSubDoc === 'item'"
      :config="selectedConfig"
      :deliveryId="activeDeliveryId"
      :orderNumber="order.order_number"
      @closeItemView="closeItemView"
      :isReadOnlyUser="isReadOnlyUser"
    >
    </ItemDocuments>
    <!-- end of item details -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { keyBy } from 'lodash';
import TagwithAttachment from '@/components/orders/TagwithAttachment';
import DocumentCountBadge from '@/components/orders/DocumentCountBadge';
import CartonDocuments from '@/components/orders/CartonDocuments';
import ItemDocuments from '@/components/orders/ItemDocuments';

import PrintDocumentsMixin from '@/components/orders/mixins/PrintDocumentsMixin';

export default {
  components: {
    TagwithAttachment,
    DocumentCountBadge,
    CartonDocuments,
    ItemDocuments,
  },
  props: ['order', 'deliveryId', 'isDocumentlisting', 'depotRefId', 'depots', 'parentDelivery'],
  mixins: [PrintDocumentsMixin],
  data() {
    return {
      numeric: null,
      documentsConfig: [],
      indentDocuments: [],
      checkbox1: null,
      activeName2: null,
      activeDeliveryId: null,
      isLoadingData: false,
      checked: false,

      // documents list
      shipmentDocuments: [],
      failedDocuments: {},
      currentDeliveryDocuments: [],
      currentCartonDocuments: [],
      isSubDocView: false,
      selectedConfigKey: null,
      selectedDocuments: [],
      currentCartonDocuments: [],
      currentSubDoc: null,
      reTriggerLoading: false,
      retryAllLoading: false,
      refreshLoading: false,
      currentDepotId: null,
    };
  },
  async created() {
    try {
      this.isLoadingData = true;
      // get the depot based config details
      let depotId = this.order && this.order.sources && this.order.sources[0].location_id;
      if (!depotId) {
        const depotDetails = this.depots.find(val => val.reference_id === this.depotRefId);
        depotId = depotDetails && depotDetails.id;
      }
      this.currentDepotId = depotId;
      const result = await this.$store.dispatch('settings/getDocumentConfig', {
        depot_id: depotId,
      });
      if (result && !result.error) {
        this.documentsConfig = _.orderBy(
          result,
          [val => val.display_name.toLowerCase()],
          ['asc'],
        );
      }
      // get the order based attachment details
      if (this.documentsConfig.length) {
        // await this.getShipmentDocuments();
        if (this.deliveryIdList && this.deliveryIdList.length) {
          this.activeDeliveryId = this.deliveryIdList[0].id;
          this.changeDeliveryTab();
        }
        await this.getShipmentDocuments();
        this.getFailedDocument();
      }
      this.$WebSocketPrinter.init();
    } catch (err) {
      this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
    } finally {
      this.isLoadingData = false;
    }
  },
  computed: {
    ...mapGetters({
      deliverySummary: 'order/deliverySummary',
      currentUser: 'app/currentUser',
    }),
    deliveryIdList() {
      if (this.deliveryId) {
        const deliveryArray = this.deliveryId.split(',');
        const deliveryDetails = [];
        // eslint-disable-next-line no-unused-expressions
        deliveryArray && deliveryArray.length && deliveryArray.forEach((_delivery) => {
          const obj = {};
          obj.id = _delivery;
          obj.parent = _delivery === this.parentDelivery;
          deliveryDetails.push(obj);
        });
        return deliveryDetails;
      }
      return (
        this.deliverySummary && this.deliverySummary.map((val) => {
          const obj = {};
          obj.id = val.delivery_id;
          obj.parent = val.is_parent_delivery;
          return obj;
        })
      );
    },
    isReadOnlyUser() {
      return this.currentUser.role.type === 'read_only';
    },
    getAllCartonDocKeyName() {
      const cartonDocs =
        this.documentsConfig &&
        this.documentsConfig.filter(val => val.print_level === 'carton' && val.document_code.key !== 'shipment_label');
      const carrierDocuments =
        this.documentsConfig &&
        this.documentsConfig.filter(val => val.carrier_label === true);
      const documentKeys = carrierDocuments && carrierDocuments.length && carrierDocuments.map(_item => _item.document_code.key);
      const cartonDocsList = [];
      const carrierDocConfig = [];
      for (let i = 0; i < cartonDocs.length; i += 1) {
        const subType = documentKeys && documentKeys.includes(cartonDocs[i].document_code.key) ? 'carrier' : '';
        if (subType !== 'carrier') {
          cartonDocsList.push({
            name: cartonDocs[i].display_name,
            key: cartonDocs[i].document_code.key,
            default_copies: cartonDocs[i].default_copies,
            type_of_printer: cartonDocs[i].type_of_printer,
          });
        } else {
          carrierDocConfig.push({
            name: cartonDocs[i].display_name,
            key: cartonDocs[i].document_code.key,
            default_copies: cartonDocs[i].default_copies,
            type_of_printer: cartonDocs[i].type_of_printer,
          });
        }
      }
      const shipmentLabelConfig =
        (this.documentsConfig &&
        this.documentsConfig.find(val => val.document_code.key === 'shipment_label')) || {};
      cartonDocsList.push({
        name: shipmentLabelConfig.display_name || 'Shipment label',
        key: 'shipment_label',
        default_copies: shipmentLabelConfig.default_copies || 1,
        type_of_printer: shipmentLabelConfig.type_of_printer || 'ZEBRA',
        subDocumentConfiguration: carrierDocConfig || [],
      });
      return cartonDocsList;
    },
    getAllItemDocKeyName() {
      const itemDocs =
        this.documentsConfig &&
        this.documentsConfig.filter(val => val.print_level === 'item');
      const itemDocsList = itemDocs.map(itemDoc => ({
        name: itemDoc.display_name,
        key: itemDoc.document_code.key,
        default_copies: itemDoc.default_copies,
        type_of_printer: itemDoc.type_of_printer,
      }));
      return itemDocsList;
    },
  },
  methods: {
    async changeDeliveryTab() {
      try {
        const params = {
          indent_id: this.order.order_number,
          printing_level: 'delivery',
          delivery_id: this.activeDeliveryId,
        };
        const result = await this.$store.dispatch(
          'order/getAllPackingDocuments',
          params,
        );
        if (result && !result.error) {
          this.currentDeliveryDocuments = result;
        } else {
          this.$errorMessage({ message: 'Documents fetching failed!' });
        }
      } catch (err) {
        this.$errorMessage({ message: 'Documents fetching failed!' });
      }
    },
    async regenerateAllDocuments() {
      this.retryAllLoading = true;
      try {
        const params = {
          indent_id: this.order.id,
        };
        const result = await this.$store.dispatch(
          'order/regenerateDocuments',
          params,
        );
        if (result && !result.error) {
          await this.getShipmentDocuments();
        } else {
          this.$errorMessage({ message: 'Documents fetching failed!' });
        }
      } catch (err) {
        this.$errorMessage({ message: 'Documents retry all failed!' });
      }
      this.retryAllLoading = false;
    },

    async reTriggerDocuments() {
      try {
        this.reTriggerLoading = true;
        const params = {
          indent_id: this.order.order_number,
          // todo: check if multiple delivery id is psbl
          delivery_id: this.deliveryIdList[0].id.toString(),
        };
        const result = await this.$store.dispatch(
          'order/reTriggerDocuments',
          params,
        );
        if (result && !result.error) {
          await this.getShipmentDocuments();
          this.$successMessage({ message: 'Documents have successfully be re-triggered!' });
        } else {
          this.$errorMessage({ message: 'Documents fetching failed!' });
        }
      } catch (err) {
        this.$errorMessage({ message: 'Documents re-trigger failed!' });
      } finally {
        this.reTriggerLoading = false;
      }
    },
    viewCartonDocuments(selectedConfig) {
      this.isSubDocView = true;
      this.currentSubDoc = 'carton';
      this.selectedConfig = selectedConfig;
    },
    closeCartonView() {
      this.isSubDocView = false;
      this.currentSubDoc = null;
      this.selectedDocuments = [];
    },
    viewItemDocuments(selectedConfig) {
      this.isSubDocView = true;
      this.currentSubDoc = 'item';
      this.selectedConfig = selectedConfig;
    },
    closeItemView() {
      this.isSubDocView = false;
      this.currentSubDoc = null;
      this.selectedDocuments = [];
    },
    async getShipmentDocuments() {
      this.refreshLoading = true;
      try {
        const params = {
          printing_level: 'shipment',
        };
        if (this.order && this.order.order_number) {
          params.indent_id = this.order.order_number;
        } else if (this.deliveryId) {
          const deliveryArray = this.deliveryId.split(',');
          const parentData = deliveryArray && deliveryArray
            .find(_delivery => _delivery === this.parentDelivery);
          params.delivery_id = parentData || deliveryArray[0];
        }
        const result = await this.$store.dispatch(
          'order/getAllPackingDocuments',
          params,
        );
        if (result && !result.error) {
          this.shipmentDocuments = result;
        } else {
          this.$errorMessage({ message: 'Documents fetching failed!' });
        }
      } catch (err) {
        this.$errorMessage({ message: 'Documents fetching failed!' });
      }
      this.refreshLoading = false;
    },
    async getFailedDocument() {
      try {
        const param = {};
        if (this.order && this.order.order_number) {
          param.orderNumber = this.order.order_number;
        } else if (this.deliveryId) {
          param.delivery = this.deliveryId;
        }
        const result = await this.$store.dispatch(
          'order/fetchFailedDocuments',
          param,
        );
        if (result) {
          this.failedDocuments = keyBy(result, 'type');
        }
      } catch (error) {
        this.$errorMessage({ message: 'Unexpected error!' });
      }
    },
  },
};
</script>

<style lang="scss">
.document-wrapper {
  background-color: #fff;
  margin: 40px 20px 20px;
  padding: 20px;
  .drawer-sub-title {
    font-size: 1.2rem;
  }
  .content-scroll-inner {
    width: 100% !important;
    .collapse-slider {
      margin: 0 !important;
    }
  }
}
</style>
